import { Tag, TagProps } from "@stone-payments/jade";

type OpenStatusTagProps = {
  status?: "always_open" | "always_closed" | "scheduled";
};

const statusMap = {
  always_open: {
    label: "Aberto",
    color: "positive",
  },
  always_closed: {
    label: "Fechado",
    color: "negative",
  },
  scheduled: {
    label: "Aberto",
    color: "positive",
  },
};

export const OpenStatusTag = ({
  status = "always_open",
}: OpenStatusTagProps) => {
  return (
    <Tag
      variant={statusMap[status].color as TagProps["variant"]}
      size="medium"
      as="span"
    >
      {statusMap[status].label}
    </Tag>
  );
};
